import { Chain } from 'wagmi';

import { makeThrowable } from '~utils/error/errorHandlers';

//supported chains
export enum NetworkIds {
  ARBITRUM_RINKEBY = 421611,
  ARBITRUM_ONE = 42161,
}

//RPC Endpoints
export const RPCConfig: { [index in NetworkIds]: Chain } = {
  [NetworkIds.ARBITRUM_RINKEBY]: {
    id: NetworkIds.ARBITRUM_RINKEBY,
    name: 'Arbitrum Testnet',
    network: 'arbitrum-rinkeby',
    nativeCurrency: {
      name: 'Ethereum',
      symbol: 'AETH',
      decimals: 18,
    },
    rpcUrls: {
      default: { http: ['https://rinkeby.arbitrum.io/rpc'] },
      public: { http: ['https://rinkeby.arbitrum.io/rpc'] },
    },
    blockExplorers: { default: { name: 'Arbiscan Rinkeby', url: 'https://testnet.arbiscan.io/' } },
    testnet: true,
  },
  [NetworkIds.ARBITRUM_ONE]: {
    id: NetworkIds.ARBITRUM_ONE,
    name: 'Arbitrum One',
    network: 'arbitrum-one',
    nativeCurrency: {
      name: 'Ethereum',
      symbol: 'AETH',
      decimals: 18,
    },
    rpcUrls: {
      default: { http: ['https://arb1.arbitrum.io/rpc'] },
      public: { http: ['https://arb1.arbitrum.io/rpc'] },
    },
    blockExplorers: { default: { name: 'Arbiscan', url: 'https://arbiscan.io/' } },
    testnet: false,
  },
};

export function getRPCConfig(network: NetworkIds = NetworkIds.ARBITRUM_ONE): Chain {
  if (network in RPCConfig) {
    return RPCConfig[network];
  } else {
    throw makeThrowable('Invalid network. Cannot get RPC!');
  }
}

export default RPCConfig;
